(function () {
    var STORAGE_KEY = 'vb_popup_dismissed_until';
    var overlay = document.getElementById('vb-popup-overlay');
    var closeBtn = document.getElementById('vb-popup-close');
    var noThanksBtn = document.getElementById('vb-popup-nothanks');
    var formSubmitted = window.vbPopupFormSubmitted || false;

    function isDismissed() {
      var until = localStorage.getItem(STORAGE_KEY);
      if (!until) return false;
      return Date.now() < parseInt(until, 10);
    }

    function dismiss(days) {
      var until = Date.now() + days * 24 * 60 * 60 * 1000;
      localStorage.setItem(STORAGE_KEY, until.toString());
      overlay.classList.remove('vb-popup-visible');
    }

    function showPopup() {
      if (isDismissed() || sessionStorage.getItem('vb_popup_shown')) return;
      overlay.classList.add('vb-popup-visible');
      sessionStorage.setItem('vb_popup_shown', '1');
    }

    if (formSubmitted) {
      overlay.classList.add('vb-popup-visible');
    } else if (!isDismissed()) {
      var shownByTimer = false;
      var timer = setTimeout(function () {
        shownByTimer = true;
        showPopup();
      }, 15000);

      window.addEventListener('scroll', function onScroll() {
        if (window.scrollY > 500 && !shownByTimer) {
          clearTimeout(timer);
          showPopup();
          window.removeEventListener('scroll', onScroll);
        }
      });
    }

    closeBtn.addEventListener('click', function () {
      dismiss(7);
    });
    noThanksBtn.addEventListener('click', function () {
      dismiss(30);
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) dismiss(7);
    });
  })();